<template>
  <v-toolbar flat light dense color="primaryLight1" :style="textColorStyle">
    <v-icon left :dark="isDarkTheme" color="neutralGray">mdi-calendar</v-icon>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-toolbar-title v-bind="attrs" v-on="on">
          <h4>{{ data.Subject }}</h4>
        </v-toolbar-title>
      </template>
      <span style="word-break: break-word" v-text="data.Subject"></span>
    </v-tooltip>
    <v-spacer></v-spacer>
    <v-btn
      class="mr-1"
      color="neutralGray"
      :dark="isDarkTheme"
      small
      icon
      @click="onClose"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import customFunctions from "@/codeFiles/taskHelper.js";
export default {
  name: "QuickInfoHeader",
  data() {
    return {
      data: {},
      selection: [],
      items: ["Foo", "Bar", "Fizz", "Buzz"],
    };
  },
  computed: {
    headerColor() {
      return this.data.meetingType.color || "#F5CBA7";
    },

    isDarkTheme() {
      return customFunctions.getContrast(this.headerColor);
    },
    textColorStyle() {
      return this.isDarkTheme ? "color:white" : "color:#424242";
    },
  },
  methods: {
    onClose,
  },
};

function onClose() {
  //console.log(JSON.stringify(this.data));
  this.$parent.$el.ej2_instances[0].quickPopup.quickPopupClose();
}
</script>

<style scoped>
.v-tooltip {
  z-index: 10003 !important;
}
</style>